import React from 'react';
import { LinkButton } from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, type UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

type Props = {
	projectsDirectoryUrl: string;
	actionSubjectId: string;
};

export const EmptyStateDeepDiveCard = (props: Props): React.JSX.Element => {
	const viewAllProjectsGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.viewAllProjectsGalaxia
		: messages.viewAllProjects;
	const emptyStateDescriptionGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.emptyStateDescriptionGalaxia
		: messages.emptyStateDescription;
	const emptyStateHeaderGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.emptyStateHeaderGalaxia
		: messages.emptyStateHeader;
	const { projectsDirectoryUrl, actionSubjectId } = props;
	const { formatMessage } = useIntl();
	return (
		<EmptyState
			description={formatMessage(emptyStateDescriptionGalaxia)}
			header={formatMessage(emptyStateHeaderGalaxia)}
			primaryAction={
				<LinkButton
					appearance="primary"
					href={projectsDirectoryUrl}
					onClick={(_, analyticsEvent: UIAnalyticsEvent) =>
						fireUIAnalytics(analyticsEvent, actionSubjectId)
					}
				>
					{formatMessage(viewAllProjectsGalaxia)}
				</LinkButton>
			}
		/>
	);
};
